import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { defineMessages } from "react-intl"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import {
  CONFIRM_DIALOG_YES,
  CONFIRM_DIALOG_NO,
  CONFIRM_DIALOG_CLOSE
} from "./confirmDialogActions"
import ButtonCancel from "../buttons/ButtonCancel"
import { words } from "../../i18n/lstrings"
import useSmartFormat from "../../i18n/useSmartFormat"

const messages = defineMessages({
  cancel: {
    defaultMessage: "Cancel",
    id: "word.cancel"
  },
  title: {
    defaultMessage: "Confirm",
    id: "dialog.confirm.title"
  },
  message: {
    defaultMessage: "Are you sure ?",
    id: "dialog.confirm.message"
  }
})

/**
 * A ConfirmDialog modal connected to redux store.
 * @returns {*}
 * @constructor
 */
export default function ConfirmDialog() {
  const format = useSmartFormat()
  const dispatch = useDispatch()
  const confirmDialogState = useSelector((state) => state.confirmDialog)

  const { isOpen, title, message } = confirmDialogState

  const realIsOpen = isOpen || false
  const realTitle = format({ intlMsgDesc: title, orDefaultMsg: messages.title })
  const realMessage = format({
    intlMsgDesc: message,
    orDefaultMsg: messages.message
  })

  const handleClose = () => {
    dispatch(CONFIRM_DIALOG_CLOSE())
  }

  const handleYes = () => {
    dispatch(CONFIRM_DIALOG_YES())
  }

  const handleNo = () => {
    dispatch(CONFIRM_DIALOG_NO())
  }

  return (
    <Dialog
      open={realIsOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{realTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" color="textPrimary">
          {realMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="buttons-right-container">
        <ButtonCancel onClick={handleNo} />
        <Button onClick={handleYes} variant="contained" color="primary">
          {format(words.yes)}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
